type ConfigProps = { v1?: boolean; v2?: boolean; mania: 'mania1' | 'mania2' }

class Config {
  props: ConfigProps | null = null

  set(props: ConfigProps) {
    this.props = props
  }

  get() {
    return this.props
  }
}

const ConfigAds = new Config()

export default ConfigAds
